// extracted by mini-css-extract-plugin
export default {"leagueNameSetup":"LeagueNameSetup_leagueNameSetup__ft0Tu","content":"LeagueNameSetup_content__16738","leagueName":"LeagueNameSetup_leagueName__RWeYY"};